import React from 'react'
import PropTypes from 'prop-types'
import Input from '../../Input'
import styles from '../Table.css'

// custom Filter override for default griddle table
export default class Filter extends React.Component {
  static propTypes = {
    setFilter: PropTypes.func,
    style: PropTypes.object,
    className: PropTypes.string
  }

  setFilter = (e) => {
    this.props.setFilter(e.target.value);
  }

  render() {
    return (
      <div className={styles.search}>
        <Input
          icon="search"
          type="text"
          name="filter"
          kind='transparent'
          placeholder="Search"
          onChange={this.setFilter}
          style={this.props.style}
          className={this.props.className}
          debounce={0}
        />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src/components/Table/components/Search.js